"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAGGING_LAG_SECONDS = exports.STALE_HEARTBEAT_SECONDS = exports.CAUGHT_UP_LAG_SECONDS = exports.HEARTBEAT_INTERVAL_MS = exports.DECODE_FAILURE_GRACE_MS = exports.TOMBSTONE_TTL_SECONDS = exports.isReservedId = exports.SWEEP_ID = exports.META_ID = exports.leasePrefix = exports.LEASE_CONTAINER = exports.CONTAINER = exports.RULES_VERSION = void 0;
// Bump on any derivation rule change: the projection replays the feed under a new lease prefix.
exports.RULES_VERSION = 1;
exports.CONTAINER = 'device_markers';
exports.LEASE_CONTAINER = 'device_markers_leases';
const leasePrefix = (version = exports.RULES_VERSION) => `markers.v${version}.`;
exports.leasePrefix = leasePrefix;
exports.META_ID = '__meta__';
exports.SWEEP_ID = '__sweep__';
const isReservedId = (id) => id.startsWith('__');
exports.isReservedId = isReservedId;
exports.TOMBSTONE_TTL_SECONDS = 604_800;
exports.DECODE_FAILURE_GRACE_MS = 86_400_000;
exports.HEARTBEAT_INTERVAL_MS = 60_000;
exports.CAUGHT_UP_LAG_SECONDS = 120;
exports.STALE_HEARTBEAT_SECONDS = 900;
exports.LAGGING_LAG_SECONDS = 600;
//# sourceMappingURL=constants.js.map